import React from 'react';
import { DeleteIcon, DownloadIcon } from '../Icons';


const maxFileChar = 52;

const FileName = ({ fileName, onDownload, onDelete }) => {
    const isLong = fileName?.length > maxFileChar;
    const displayName = isLong ? fileName?.slice(0, maxFileChar) + '...' : fileName;

    return (
        <div className="grid grid-cols-[1fr_auto_auto] items-center w-full max-w-md gap-2 py-2 rounded">
            <div className="text-primaryColor font-semibold">{displayName}</div>

            {onDownload ? <button
                onClick={onDownload}
                className="text-primaryColor hover:text-primaryColor"
                aria-label="Download"
            >
                <DownloadIcon className="w-5 h-5" />
            </button> : null}

            {onDelete && (
                <button
                    onClick={onDelete}
                    className="text-red-500 hover:text-red-600"
                    aria-label="Delete"
                >
                    <DeleteIcon className="w-5 h-5" />
                </button>
            )}
        </div>
    );
};

export default FileName;
